// here is where the API data is consumed then reformed into a usable object for component consumption

import MicroContent from "../api/GetMicroContent";

class MicroContentModel {
  constructor(microContent) {
    this.microContent = microContent;
    return this.createMicroContent();
  }

  createMicroContent() {
    const content = this.microContent.reduce(
      (obj, { micro_content, title_slug }) => {
        if (!obj[title_slug]) {
          obj[title_slug] = micro_content;
        }
        return obj;
      },
      {}
    );

    return content;
  }
}

export default async function() {
  const getMicroContent = await MicroContent();
  // console.log("Micro Content Model", getMicroContent);
  return new MicroContentModel(getMicroContent);
}
